import API from '../../api/api';
import { Link } from 'react-router-dom';
import React, { Component } from 'react';
import ReactTimeAgo from 'react-time-ago';
import '../../styles/css/Jobs/bidCard.css';
import DoneIcon from '@material-ui/icons/Done';
import TodayIcon from '@material-ui/icons/Today';
import ScheduleIcon from '@material-ui/icons/Schedule';
import StarRateIcon from '@material-ui/icons/StarRate';
import StarRatingComponent from 'react-star-rating-component';
import AccountCircleIcon from '@material-ui/icons/AccountCircle';

const token = localStorage.getItem('token');

class BidCard extends Component {
    constructor(props) {
        super(props);
        this.state = {
            bids: [],
            isAccepting: false,
            isRejecting: false,
        }
    }

    componentDidMount() {
        this.setState({ bids: this.props.bidsData })
    }

    componentDidUpdate(prevProps) {
        if (this.props.bidsData !== prevProps.bidsData) {
            this.setState({ bids: this.props.bidsData })
        }
    }

    acceptBid = (e, surveyorId) => {
        e.preventDefault();
        this.setState({ isAccepting: true }, () =>
            this.props.acceptingBid
        )

        this.setState({ isAccepting: true })
        API.post('job/accept/' + this.props.jobId + '/' + surveyorId)
            .then(res => {
                this.setState({ isAccepting: false })
                this.props.acceptBid()
            })
            .catch((err) => {
                this.setState({ isAccepting: false })
                console.log("AXIOS ERROR: ", err);
            })
    }

    rejectBid = (e, surveyorId) => {
        e.preventDefault();
        this.setState({ isRejecting: true }, () =>
            this.props.removingBid
        )

        this.setState({ isRejecting: true })
        API.post('job/reject/' + this.props.jobId + '/' + surveyorId)
            .then(res => {
                this.setState({ isRejecting: false })
                this.props.removeBid(surveyorId)
            })
            .catch((err) => {
                this.setState({ isRejecting: false })
                console.log("AXIOS ERROR: ", err);
            })
    }

    render() {

        const timeZoneDiff = new Date().getTimezoneOffset();
        const { bids, isAccepting, isRejecting } = this.state;

        return (
            bids.map(bid => {
                return (
                    <div className="projectCardRoot" key={bid.id}>
                        <div className={token && token.length > 0 ? "projectCardMainLogin desktopDivFlex" : "projectCardMain desktopDivFlex"}>
                            <div className="projectCardLeft">
                                <AccountCircleIcon className="protractorSvg" />
                            </div>
                            <div className="projectCardMiddle">
                                <div className="bidderNameHeader">
                                    <Link to={"/Profile/" + bid.survey_id}>
                                        <p className="projectCardTitle bidCardNameLink">{bid.survey_name}</p>
                                    </Link>
                                    <div className="projectCardStar">
                                        <StarRatingComponent
                                            name="rate1"
                                            starCount={5}
                                            value={Math.round(bid.user_rating, 10)}
                                            starColor={"#9cd5f1"}
                                            emptyStarColor={"#b1b1b1"}
                                            renderStarIcon={() => <StarRateIcon style={{ width: '20px' }} />}
                                            editing={false}
                                        />
                                    </div>
                                </div>
                                <p className="projectCardDesc" id="projectCardDesc">{bid.description}</p>
                                <div className="projectCardDetails">
                                    <div className="projectCardTime">
                                        <ScheduleIcon />
                                        <span>Placed &nbsp;
                                            <ReactTimeAgo
                                                date={
                                                    timeZoneDiff >= 0 ?
                                                        new Date(new Date(bid.created_at.date).getTime() - timeZoneDiff * 60000)
                                                        :
                                                        new Date(new Date(bid.created_at.date).getTime() - timeZoneDiff * 60000)
                                                }
                                            />
                                        </span>
                                    </div>
                                    <div className="projectCardStar">
                                        <TodayIcon />
                                        <div style={{ padding: '3px' }}>
                                            Get done in &nbsp;{bid.duration} &nbsp; days
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="projectCardRight">
                                <div className="projectCardCostDiv">
                                    <div className="projectCardCost">
                                        <span className="projectCardCostMain">${bid.amount.split(".")[0]}</span>
                                        <span className="projectCardCostUnit">&nbsp;USD</span>
                                    </div>
                                    <div className="projectCardBidBtn displayFlex">
                                        <div className="rejectBid" onClick={(e) => this.rejectBid(e, bid.survey_id)} disabled={isRejecting ? true : false}>
                                            <div>
                                                Reject
                                            </div>
                                        </div>
                                        <button onClick={(e) => this.acceptBid(e, bid.survey_id)} disabled={isAccepting ? true : false}>
                                            <div>
                                                <DoneIcon className="bidBtnIconAccept" />
                                                Accept
                                            </div>
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className={token && token.length > 0 ? "projectCardMainLoginMobile mobileDiv" : "projectCardMainMobile mobileDiv"}>
                            <div className="projectCardMiddleMobile">
                                <div>
                                    <Link to={"/Profile/" + bid.survey_id}>
                                        <p className="projectCardTitleMobile bidCardNameLink">{bid.survey_name}</p>
                                    </Link>
                                </div>
                                <p className="projectCardDescMobile" id="projectCardDesc">{bid.description}</p>
                                <div className="projectCardDetailsMobile">
                                    <div className="projectCardTimeMobile">
                                        <ScheduleIcon />
                                        <span>Placed &nbsp;
                                        <ReactTimeAgo
                                                date={
                                                    timeZoneDiff >= 0 ?
                                                        new Date(new Date(bid.created_at.date).getTime() - timeZoneDiff * 60000)
                                                        :
                                                        new Date(new Date(bid.created_at.date).getTime() - timeZoneDiff * 60000)
                                                }
                                            />
                                        </span>
                                    </div>
                                    <div className="projectCardStarMobile projectCardCalMobile">
                                        <TodayIcon />
                                        <div style={{ padding: '3px' }}>
                                            Get done in &nbsp;{bid.duration} &nbsp; days
                                        </div>
                                    </div>
                                    <div className="projectCardStarMobile userStarRatingMobile">
                                        <span>Rating&nbsp;</span>
                                        <StarRatingComponent
                                            name="rate1"
                                            starCount={5}
                                            value={Math.round(bid.user_rating, 10)}
                                            starColor={"#9cd5f1"}
                                            emptyStarColor={"#b1b1b1"}
                                            renderStarIcon={() => <StarRateIcon style={{ width: '20px' }} />}
                                            editing={false}
                                        />
                                    </div>
                                </div>
                            </div>
                            <div className="projectCardRightMobile">
                                <div className="projectCardCostDivMobile">
                                    <div className="projectCardCostMobile">
                                        <span className="projectCardCostMainMobile">${bid.amount.split(".")[0]}</span>
                                        <span className="projectCardCostUnit">&nbsp;USD</span>
                                    </div>
                                    <div className="projectCardBidBtnMobile">
                                        <button onClick={(e) => this.acceptBid(e, bid.survey_id)} disabled={isAccepting ? true : false}>
                                            <div>
                                                <DoneIcon className="bidBtnIconAccept" />
                                                Accept
                                            </div>
                                        </button>
                                        <div className="rejectBid rejectBidMobile" onClick={(e) => this.rejectBid(e, bid.survey_id)} disabled={isRejecting ? true : false}>
                                            <div>
                                                Reject
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                )
            })

        )
    }
}

export default BidCard;


// WEBPACK FOOTER //
// ./src/pages/Jobs/bidCard.js